const isDate = (value) => {
  return !isNaN(Date.parse(value))
}

export default {
  props: {
    date: {
      type: String,
      required: true,
      validator: isDate,
    },
    max: {
      type: String,
      validator: isDate,
    },
    returnFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    showFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
  },
  computed: {
    showDate() {
      return this.$moment(this.date).format(this.showFormat)
    },
  },
  methods: {
    convert(date) {
      return date.format(this.returnFormat)
    },
    preDay() {
      const temp = this.$moment(this.date).add(-1, 'days')
      this.$emit('update:date', this.convert(temp))
    },
    nextDay() {
      const temp = this.$moment(this.date).add(+1, 'days')
      this.$emit('update:date', this.convert(temp))
    },
  },
}
